var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"已占用"}},[_c('Bind')],1),_c('el-tab-pane',{attrs:{"label":"已冻结"}},[_c('Frozen')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }